/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import dayjs from "dayjs";
import type { EmberChangeset } from "ember-changeset";
import type { ProtocolSectionArgs } from "../../base-components/base-protocol-item";

export default class TreatmentHistoryProtocolProstatectomyTotalComponent extends Component<ProtocolSectionArgs> {
  @action
  onChangesetUpdate(changeset: EmberChangeset, propertyName: string): void {
    if (propertyName == "surgery") {
      this.updateDateFromSurgeryDate();
    }
    this.args.onChangesetUpdate(changeset);
  }

  private get surgeryDate(): Date | undefined {
    return this.args.changeset.get("surgery");
  }

  private updateDateFromSurgeryDate(): void {
    if (!this.surgeryDate) return;

    const c = this.args.changeset;
    const d = dayjs(this.surgeryDate);

    c.set("remove-urinary-catheter", d.add(7, "day").toDate());
    c.set("post-operative-consultation", d.add(30, "day").toDate());
    c.set("follow-up-consultation-1", d.add(60, "day").toDate());
    c.set("follow-up-consultation-2", d.add(90, "day").toDate());
  }
}
